import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/Common/Services/login.service';
import { MatDialog } from '@angular/material';
import { LoginComponent } from '../login/login.component';
import { ToastrService } from 'ngx-toastr';
import { Router, NavigationExtras } from '@angular/router';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  ngOnInit(): void {
    throw new Error("Method not implemented.");
  }
  goBack() {
    window.history.back();
  }
  contactclick(){
    this.router.navigate(["/contactUs"])
  }
  selected = 'ENG';


  
  constructor(public loginservice:LoginService,private toastr: ToastrService,public dialog: MatDialog,private router:Router) {


   }
   openLoginDialog(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
        panelClass: 'loginpopupbox'
    });
  }


  travelFaq(){
    
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "product" : "TRAVEL"
      }
    }
    this.router.navigate(["/faqtravelinsurance"], navigationExtras);
  }
  
  healthFaq(){
    
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "product" : "HEALTH"
      }
    }
    this.router.navigate(["/faqhealthinsurance"], navigationExtras);
  }

  motorFaq(){
    
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "product" : "MOTOR"
      }
    }
    this.router.navigate(["/faqmotorinsurance"], navigationExtras);
  }

  fireFaq(){
    
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "product" : "FIRE"
      }
    }
    this.router.navigate(["/faqfireinsurance"], navigationExtras);
  }
    
}

